export const defInputClass = "block w-full min-w-0 transition duration-150 ease-in-out";
export const inputTextSmClass = "sm:text-sm sm:leading-5";
export const inputErrClass = "border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red";